import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress'


export const LoadingAnimation = CircularProgress
